/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import router from '@/router'
import { createPinia } from 'pinia'
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import { VDateInput } from 'vuetify/labs/VDateInput'

export function registerPlugins(app) {
  app.use(vuetify)
  app.use(router)
  app.use(createPinia()),

    app.component('VTimePicker', VTimePicker)
  app.component('VDateInput', VDateInput)
}
